import { MultiSelectDropdown, Search } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { type FilterOptions } from '../hooks/use-action-items-filters';

interface ActionItemsFiltersProps {
  searchText: string;
  statusFilters: string[];
  personFilters: string[];
  topicFilters: string[];
  filterOptions: FilterOptions;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusChange: (values: string[]) => void;
  onPersonChange: (values: string[]) => void;
  onTopicChange: (values: string[]) => void;
}

export const ActionItemsFilters: FC<ActionItemsFiltersProps> = ({
  searchText,
  statusFilters,
  personFilters,
  topicFilters,
  filterOptions,
  onSearchChange,
  onStatusChange,
  onPersonChange,
  onTopicChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex items-center gap-4">
      <div className="flex-1 max-w-sm">
        <Search
          text={searchText}
          onChange={onSearchChange}
          placeholder={t('meeting-secretary.action-items.search-placeholder')}
          className="w-full bg-white rounded"
        />
      </div>
      <div className="w-52">
        <MultiSelectDropdown
          options={filterOptions.statuses}
          selectedValues={statusFilters}
          onChange={onStatusChange}
          placeholder={t('meeting-secretary.action-items.all-statuses')}
        />
      </div>
      <div className="w-52">
        <MultiSelectDropdown
          options={filterOptions.people}
          selectedValues={personFilters}
          onChange={onPersonChange}
          placeholder={t('meeting-secretary.action-items.all-people')}
        />
      </div>
      <div className="w-52">
        <MultiSelectDropdown
          options={filterOptions.topics}
          selectedValues={topicFilters}
          onChange={onTopicChange}
          placeholder={t('meeting-secretary.action-items.all-topics')}
        />
      </div>
    </div>
  );
};
